module.exports = __webpack_public_path__ + "static/img/image_solutions_intellgent_01.218ab4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_intellgent_01.png
// module id = 98jn
// module chunks = 10